export default "__VITE_ASSET__DUuqkTTZ__"